import { render, staticRenderFns } from "./BrandSettingModel.vue?vue&type=template&id=282016fd&scoped=true"
import script from "./BrandSettingModel.vue?vue&type=script&lang=js"
export * from "./BrandSettingModel.vue?vue&type=script&lang=js"
import style0 from "./BrandSettingModel.vue?vue&type=style&index=0&id=282016fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282016fd",
  null
  
)

export default component.exports